import cn from 'clsx';
import * as React from 'react';

import * as styles from './Select.css';
import { SearchResultsTooltip } from '../SearchResultsTooltip';
import { Checkbox } from '@cian/ui-kit';
import { ISelectProps } from './types';

export function Select<T>({ options, selected, onChange, tooltipOpened, hostElement, onApply }: ISelectProps<T>) {
  const initialTooltipIndex = options.findIndex(option => selected.includes(option.value));

  const [tooltipIndex, setTooltipIndex] = React.useState<number | null>(initialTooltipIndex);

  const ref = React.useRef<HTMLUListElement>(null);

  const handleOptionChange = (option: T, index: number) => (): void => {
    setTooltipIndex(index);

    const newSelectedOptions = selected.includes(option)
      ? selected.filter(value => value !== option)
      : [...selected, option];

    onChange(newSelectedOptions);
  };

  return (
    <div className={styles['container']}>
      <ul className={cn(styles['list'])} ref={ref}>
        {options.map(({ label, value }, index) => (
          <SearchResultsTooltip
            hostElement={hostElement}
            key={value as string}
            open={tooltipIndex === index && tooltipOpened}
            placement="right"
            onApply={onApply}
          >
            <li className={cn(styles['list-item'])} onClick={handleOptionChange(value, index)}>
              <Checkbox checked={selected.includes(value)} label={label} />
            </li>
          </SearchResultsTooltip>
        ))}
      </ul>
    </div>
  );
}
